import type { RouteObject } from "react-router-dom";
import { ProductionHomePage } from "./pages/ProductionHomePage";
import { ProductionOrderListPage } from "./pages/orders/ProductionOrderListPage";
import { ProductionOrderDetailPage } from "./pages/orders/ProductionOrderDetailPage";
import { ProductionOrderCreatePage } from "./pages/orders/ProductionOrderCreatePage";
import ProductionLinePage from "@/features/production-line/ProductionLinePage";
import MaterialConsumptionPage from "@/pages/production/MaterialConsumptionPage";
import ScrapTrackingPage from "@/pages/production/ScrapTrackingPage";
import { ShortageHoldBoardPage } from "./shortageHold/pages/ShortageHoldBoardPage";
import { ShopfloorWorkInstructionsPage } from "@/features/shopfloor/pages/ShopfloorWorkInstructionsPage";
import { DowntimeBoardPage } from "@/features/shopfloor/pages/DowntimeBoardPage";
import { DowntimeReasonsPage } from "@/features/shopfloor/pages/DowntimeReasonsPage";
import {
  SerialUnitRegisterPage,
  LotFeedSessionsPage,
  SerialUnitTracePage,
  LotAffectedUnitsPage,
} from "./serialization/routes";

import RosterManagerPage from "@/features/shopfloor/roster/pages/RosterManagerPage";
import OperatorRosterAssignmentPage from "@/features/shopfloor/roster/pages/OperatorRosterAssignmentPage";
import LeaveRequestsPage from "@/features/shopfloor/roster/pages/LeaveRequestsPage";
import ShiftSwapPage from "@/features/shopfloor/roster/pages/ShiftSwapPage";
import StationAssignmentPage from "./stationAssignment/pages/StationAssignmentPage";

import { ProductionLinesHelpPage } from "@/features/production-line/pages/ProductionLinesHelpPage";
import { ProductionOrdersHelpPage } from "./pages/orders/ProductionOrdersHelpPage";
import { ProductionOrdersCreateHelpPage } from "./pages/orders/ProductionOrdersCreateHelpPage";

import { ShiftsHelpPage } from "@/features/shopfloor/pages/help/ShiftsHelpPage";
import { DowntimesHelpPage } from "@/features/shopfloor/pages/help/DowntimesHelpPage";
import { AssignmentsHelpPage } from "@/features/shopfloor/pages/help/AssignmentsHelpPage";
import { WorkInstructionsHelpPage } from "@/features/shopfloor/pages/help/WorkInstructionsHelpPage";

import { DowntimeReasonsHelpPage } from "@/features/shopfloor/pages/help/DowntimeReasonsHelpPage";

import { MaterialConsumptionHelpPage } from "@/features/production/pages/help/MaterialConsumptionHelpPage";
import { ScrapTrackingHelpPage } from "@/features/production/pages/help/ScrapTrackingHelpPage";
import { SerialUnitRegisterHelpPage } from "@/features/production/serialization/pages/help/SerialUnitRegisterHelpPage";
import { LotFeedSessionsHelpPage } from "@/features/production/serialization/pages/help/LotFeedSessionsHelpPage";
import { SerialUnitTraceHelpPage } from "@/features/production/serialization/pages/help/SerialUnitTraceHelpPage";
import { LotAffectedUnitsHelpPage } from "@/features/production/serialization/pages/help/LotAffectedUnitsHelpPage";
import ProductionHomeHelp from "./help/production-home.mdx";
import ProductionOrderDetailHelp from "./help/production-order-detail.mdx";
import LeaveRequestsHelp from "@/features/shopfloor/help/leave-requests.mdx";
import RostersHelp from "@/features/shopfloor/help/rosters.mdx";
import ShiftSwapsHelp from "@/features/shopfloor/help/shift-swaps.mdx";
import StationAssignmentsHelp from "@/features/shopfloor/help/station-assignments.mdx";

/**
 * ADR-072 Rule FMS-01/FMS-03: این آرایه در router.tsx مرکزی spread می‌شود.
 * هیچ importی از features دیگر اینجا مجاز نیست.
 */
export const productionRoutes: RouteObject[] = [
  {
    path: "help/production/consumption",
    element: <MaterialConsumptionHelpPage />,
  },
  {
    path: "help/production/scrap",
    element: <ScrapTrackingHelpPage />,
  },
  {
    path: "help/production/serialization/serial-unit-register",
    element: <SerialUnitRegisterHelpPage />,
  },
  {
    path: "help/production/serialization/lot-feed-sessions",
    element: <LotFeedSessionsHelpPage />,
  },
  {
    path: "help/production/serialization/serial-unit-trace",
    element: <SerialUnitTraceHelpPage />,
  },
  {
    path: "help/production/serialization/lot-affected-units",
    element: <LotAffectedUnitsHelpPage />,
  },
  {
    path: "help/shopfloor/shifts",
    element: <ShiftsHelpPage />,
  },
  {
    path: "help/shopfloor/downtimes",
    element: <DowntimesHelpPage />,
  },
  {
    path: "help/shopfloor/downtime-reasons",
    element: <DowntimeReasonsHelpPage />,
  },
  {
    path: "help/shopfloor/assignments",
    element: <AssignmentsHelpPage />,
  },
  {
    path: "help/shopfloor/work-instructions",
    element: <WorkInstructionsHelpPage />,
  },
  {
    path: "help/production/lines",
    element: <ProductionLinesHelpPage />,
  },
  {
    path: "help/production/orders",
    element: <ProductionOrdersHelpPage />,
  },
  {
    path: "help/production/orders/create",
    element: <ProductionOrdersCreateHelpPage />,
  },
  {
    path: "help/production/home",
    element: <ProductionHomeHelp />,
  },
  {
    path: "help/production/production-order-detail",
    element: <ProductionOrderDetailHelp />,
  },
  {
    path: "help/production/shortageHold/shortage-hold-board",
    element: <ProductionOrdersHelpPage />,
  },
  {
    path: "help/shopfloor/leave-requests",
    element: <LeaveRequestsHelp />,
  },
  {
    path: "help/shopfloor/rosters",
    element: <RostersHelp />,
  },
  {
    path: "help/shopfloor/shift-swaps",
    element: <ShiftSwapsHelp />,
  },
  {
    path: "help/shopfloor/station-assignments",
    element: <StationAssignmentsHelp />,
  },
  {
    path: "production",
    element: <ProductionHomePage />,
  },
  {
    path: "production/orders",
    element: <ProductionOrderListPage />,
  },
  {
    path: "production/orders/create",
    element: <ProductionOrderCreatePage />,
  },
  {
    path: "production/orders/:id",
    element: <ProductionOrderDetailPage />,
  },
  {
    path: "production/lines",
    element: <ProductionLinePage />,
  },
  {
    path: "production/consumption",
    element: <MaterialConsumptionPage />,
  },
  {
    path: "production/scrap",
    element: <ScrapTrackingPage />,
  },
  {
    path: "production/shortage-holds",
    element: <ShortageHoldBoardPage />,
  },
  {
    path: "production/shopfloor/work-instructions",
    element: <ShopfloorWorkInstructionsPage />,
  },
  {
    path: "production/shopfloor/downtime",
    element: <DowntimeBoardPage />,
  },
  {
    path: "production/shopfloor/downtime-reasons",
    element: <DowntimeReasonsPage />,
  },
  {
    path: "production/shopfloor/rosters",
    element: <RosterManagerPage />,
  },
  {
    path: "production/shopfloor/roster-assignments",
    element: <OperatorRosterAssignmentPage />,
  },
  {
    path: "production/shopfloor/leave-requests",
    element: <LeaveRequestsPage />,
  },
  {
    path: "production/shopfloor/shift-swaps",
    element: <ShiftSwapPage />,
  },
  {
    path: "production/serialization/register",
    element: <SerialUnitRegisterPage />,
  },
  {
    path: "production/serialization/feed-sessions",
    element: <LotFeedSessionsPage />,
  },
  {
    path: "production/serialization/trace",
    element: <SerialUnitTracePage />,
  },
  {
    path: "production/serialization/affected-units",
    element: <LotAffectedUnitsPage />,
  },
  {
    path: "production/station-assignments",
    element: <StationAssignmentPage />,
  },
];

